import { TranslationObject } from '../i18n/translation';

const namespace = 'students.psa';
const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Studenter i praksis',
    en: 'Students in work placements',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Her ser du en liste over alle studenter som skal i praksis',
    en: 'All students in work placements at your organization',
  },
  student: {
    id: `${namespace}.student`,
    nb: 'Student',
    en: 'Student',
  },
  periode: {
    id: `${namespace}.periode`,
    nb: 'Periode',
    en: 'Period',
  },
  emne: {
    id: `${namespace}.emne`,
    nb: 'Emne',
    en: 'Subject',
  },
  praksissted: {
    id: `${namespace}.praktissted`,
    nb: 'Praksissted',
    en: 'Place',
  },
  studiested: {
    id: `${namespace}.studiested`,
    nb: 'Studiested',
    en: 'Institution',
  },
  epost: {
    id: `${namespace}.epost`,
    nb: 'Epost',
    en: 'Email',
  },
  telefon: {
    id: `${namespace}.telefon`,
    nb: 'Telefon',
    en: 'Phone',
  },
  aktive: {
    id: `${namespace}.aktive`,
    nb: 'Studenter i praksis nå',
    en: 'Students in placements now',
  },
  fremtidige: {
    id: `${namespace}.fremtidige`,
    nb: 'Studenter som skal komme til praksis',
    en: 'Students coming for future placements',
  },
  gamle: {
    id: `${namespace}.gamle`,
    nb: 'Studenter som har vært i praksis',
    en: 'Students in past placements',
  },
};

export default translations;
